// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__CrNar","content":"modal_content__LvNoi"};